import { fmt, 
    is, today, future, past,
    beginMonth, monday, yesterday, tomorrow, month,
    prevMonth, nextMonth, prevYear, nextYear,
    datify
} from '../utils/date';





export default class Calendar {

    constructor(m = new Date()) {
        this.month = datify( m );
    }

    set(date) {
        this.month = datify( date );
    }

    nextMonth() {
        this.month = nextMonth( this.month );
    }

    prevMonth() {
        this.month = prevMonth( this.month );
    }

    nextYear() {
        this.month = nextYear( this.month );
    }

    prevYear() {
        this.month = prevYear( this.month );
    }

    getMonth() {
        return this.month;
    }

    getPrevMonth() {
        return prevMonth( this.month );
    }

    getNextMonth() {
        return nextMonth( this.month );
    }

    list() {
        let date = beginMonth( this.month );
        while (!monday( date )) date = yesterday( date );

        // to set HH:mm:ss in schedule calendar for subsequent
        // parsing those dates and triggering them in schedule:list event.
        // todo remove HH:mm:ss from here
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        
        const days = [];
        
        // days of previous month (since monday till current month's beginning)
        for (; month( date ) !== month( this.month ); date = tomorrow( date ))
            days.push( { 
                ...createDateData( date ),
                'prev-month': true,
            } );

        // days of current month
        for (; month( date ) === month( this.month ); date = tomorrow( date ))
            days.push( { 
                ...createDateData( date ),
                'current-month': true,
            } );

        // always show 6 weeks to avoid "jumping" calendar interface
        // between 5-week and 6-week months
        for (; days.length < 42; date = tomorrow( date ))
            days.push( { 
                ...createDateData( date ),
                'next-month': true,
            } );

        return days;
    }

    fmt(format) {
        return fmt( this.month, format );
    }
}

function createDateData(date) {
    return {
        date,
        today: is( date, today() ),
        future: future( date ),
        past: past( date ),
    };
}


// WEBPACK FOOTER //
// ./src/js/collection/calendar.js